import { render, staticRenderFns } from "./redEnvelope.vue?vue&type=template&id=570ee66c&scoped=true&"
import script from "./redEnvelope.vue?vue&type=script&lang=js&"
export * from "./redEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./redEnvelope.vue?vue&type=style&index=0&id=570ee66c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ee66c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570ee66c')) {
      api.createRecord('570ee66c', component.options)
    } else {
      api.reload('570ee66c', component.options)
    }
    module.hot.accept("./redEnvelope.vue?vue&type=template&id=570ee66c&scoped=true&", function () {
      api.rerender('570ee66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/event1/components/redEnvelope.vue"
export default component.exports